import { ReportOrganizationType, ISortable, SecurityGroup, ReportSecurityGroup, ReportSubCategory } from './';

export class Report implements ISortable{
    public ReportId:string;

    public Name:string;

    public Description:string;

    public SapReportName:string;

    public IsDeleted:boolean;

    public ReportSubCategoryId:string;

    public ReportSubCategory:ReportSubCategory;

    public SortOrder:number;

    public ReportOrganizationTypeId:string;

    public ReportOrganizationType:ReportOrganizationType;

    public ShouldShowDistrictPrompt:boolean;

    public ReportSecurityGroups:ReportSecurityGroup[];

    constructor(ReportId:string = "", Name:string = ""){
        this.ReportId = ReportId;
        this.Name = Name;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/report.ts